import React from 'react'
import computerIcon from '../../../../assets/cardEntryIcons/computer.svg';
import DataField from "../../utils/DataField"
import {getBrowserPlatformName} from "../../utils/utilsOrder"



function DeviceCard(props) {

    let device = props.order.device

    if (device == null) return null

    let fields = [
        {title: "Dispositivo", label: getBrowserPlatformName(device.browser, device.platform)},
        {title: "IP", label: device.ip},
        {title: "Sessão", label: device.session_id}
    ].filter(field => field.label != null && field.label !== "")

    if (fields.length === 0) return null

    return (
        <div className="analysisCard">
            <div style={{display: "flex"}}>
                <img className="cardTitleIconStyle" src={computerIcon} alt="computerIcon Logo" />
                <span className={["blueText", "subtitleSize", "labelSpace"].join(" ")}>Dispositivo</span>
            </div>
            <div className="internalCardContainer" style={{display: "flex", flexDirection: "column"}}>
                {fields.map((field, index) => (
                    <DataField
                        key={index}
                        title={field.title}
                        label={field.label}
                        size={"normalMediumSize"}
                        titleNoWrap={true}
                        margin="5px"
                        display={"inline"}
                        labelStyles={{wordBreak: "break-all"}}
                    />
                ))}
            </div>
        </div>
    )
}



export default DeviceCard
